import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalThemMoi } from "components/NguonVon/ThemMoi/ModalThemMoi";

export const BtnSua = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} onClick={handleShow}>
        <PopoversBootrap
          contentText="Sửa"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-edit-v2.png" />
        </PopoversBootrap>
      </a>

      {show && (
        <ModalThemMoi
          show={show}
          onHide={handleClose}
          customerId={item.CustomerID}
        />
      )}
    </>
  );
};
